/**
 * Simple Slideshow — vanilla JS, autoplay only, no dots/arrows/counter.
 * The container's aspect-ratio is set to match whichever image is becoming
 * active (read straight from the <img>'s width/height attributes, which
 * Shopify's image_tag already stamps with the real source dimensions — no
 * need to wait for the image to load), so slides of different dimensions
 * each get their own correct height instead of being cropped to one box.
 */
(function () {
  if (customElements.get('simple-slideshow')) return;

  class SimpleSlideshow extends HTMLElement {
    constructor() {
      super();
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.simple-slideshow__slide'));
      this.autoplayMs = (parseInt(this.dataset.autoplaySeconds, 10) || 5) * 1000;
      this.currentIndex = Math.max(
        0,
        this.slides.findIndex(function (slide) {
          return slide.classList.contains('is-active');
        })
      );
    }

    connectedCallback() {
      if (this.slides.length < 2) return; // nothing to rotate

      this.applyAspectRatio(this.slides[this.currentIndex]);
      this.timer = setInterval(this.advance.bind(this), this.autoplayMs);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      const current = this.slides[this.currentIndex];
      const next = this.slides[nextIndex];

      this.applyAspectRatio(next);
      current.classList.remove('is-active');
      next.classList.add('is-active');

      this.currentIndex = nextIndex;
    }

    applyAspectRatio(slide) {
      const img = slide.querySelector('img');
      if (!img) return;

      // Read the literal width/height HTML attributes, not the .width/.height
      // IDL properties — those reflect rendered layout size, which is 100%/100%
      // here by CSS, so they'd just circularly report the container's current
      // size instead of the source image's real aspect ratio.
      const width = img.getAttribute('width');
      const height = img.getAttribute('height');
      if (!width || !height) return;

      this.style.aspectRatio = width + ' / ' + height;
    }
  }

  customElements.define('simple-slideshow', SimpleSlideshow);
})();
